export const getHistoryButtonStyles = (_, { palette = {} }) => ({
  recommendationHistoryItem: {
    position: 'relative',
    top: '5px',
    marginRight: '19px',
    textAlign: 'right',
  },
  entityContentRecommendationHistory: {
    border: 'none',
    cursor: 'pointer',
    overflow: 'hidden',
    outline: 'none',
    backgroundColor: 'Transparent',
    backgroundRepeat: 'no-repeat',
  },
  entityIcon: {
    position: 'relative',
    lineHeight: '16px',
    fontSize: '16px',
    color: palette.themePrimary,
  },
  entityContent: {
    lineHeight: '16px',
    fontSize: '12px',
    color: palette.neutralPrimary,
    whiteSpace: 'nowrap',
  },
  recommendationHistoryPopover: {
    '& .popover-content': {
      padding: '11px 18px',
    },
  },
});
